import React from "react";
import { useDispatch } from "react-redux";
import { useGetUserQuery } from "state/api";
import { logout, setCredentials } from "state/authSlice";
import Loader from "components/Loader";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const UserHeader = () => {
  const dispatch = useDispatch();
  const { userToken } = useSelector((state) => state.auth);

  const { data, isLoading, error } = useGetUserQuery("userDetails", {
    pollingInterval: 15 * 60 * 1000,
  });

  React.useEffect(() => {
    if (data) {
      dispatch(setCredentials(data));
    }
  }, [data, dispatch]);

  React.useEffect(() => {
    if (error) {
      dispatch(logout());
    }
  }, [error, dispatch]);

  // if loading return loader component else if error return error message else return outlet

  if (isLoading && userToken) {
    return <Loader />;
  }

  return <Outlet />;
};

export default UserHeader;
